$(function () {
  $('.js-slider').slick({
    autoplay: true,
    pauseOnHover: false,
    arrows: true,
    dots: true,
    dotsClass: 'products_slider_dots',
    centerMode: true,
    centerPadding: '20%',
    prevArrow: '<button class="ps_arrow ps_arrow_prev"></button>',
    nextArrow: '<button class="ps_arrow ps_arrow_next"></button>',
    responsive: [
      {
        breakpoint: 767,
        settings: {
          centerMode: false
        }
      }
    ]
  });

  $('.js-manufacturing_slider').slick({
    fade: true,
    autoplay: true,
    pauseOnHover: false,
    arrows: false,
    dots: true,
    dotsClass: 'products_slider_dots'

  });
});
